// extracted by mini-css-extract-plugin
module.exports = {"iconWrp":"styles_iconWrp__2zsgw","icon":"styles_icon__2s0bw","text":"styles_text__wbxOz"};